import type { Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    color: theme.palette.info.main,
    '& > span': {
      fontSize: 14,
      justifyContent: 'start',
    },
  },
}));

interface Props {
  label: string;
  itemName: string;
  onAction: () => void;
}

function ActionItem({ label, itemName, onAction }: Props) {
  const classes = useStyles();
  return (
    <Box pb={1} pl={1} pr={1} pt={1}>
      <Button
        className={classes.button}
        fullWidth
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onAction();
        }}
      >{`${label} ${itemName}`}</Button>
    </Box>
  );
}

export default ActionItem;
